import React, { FC } from "react";

import Image from "next/image";

import { CATEGORIES } from "lib/enum/categories";

import styles from "./plan-icon.module.scss";

const mapTypeToIconSVG: Record<number, string> = {
  [CATEGORIES.CUSTOM]: "/bff/plans/plan-icons/emoji-speach-bubble.png",
  [CATEGORIES.COFFEE]: "/bff/plans/plan-icons/emoji-soda.png",
  [CATEGORIES.PIZZA]: "/bff/plans/plan-icons/emoji-pizza.png",
  [CATEGORIES.OUTDOORS]: "/bff/plans/plan-icons/emoji-flower.png",
  [CATEGORIES.NIGHTOUT]: "/bff/plans/plan-icons/emoji-mirror-ball.png",
  [CATEGORIES.CHESS]: "/bff/plans/plan-icons/emoji-chess.png",
  [CATEGORIES.SPORTS]: "/bff/plans/plan-icons/emoji-sneaker.png",
  [CATEGORIES.CULTURE]: "/bff/plans/plan-icons/emoji-camera.png",
  [CATEGORIES.TRAVEL]: "/bff/plans/plan-icons/emoji-air-plane.png",
  [CATEGORIES.KIDS]: "/bff/plans/plan-icons/emoji-teddy-bear.png",
  [CATEGORIES.FRIENDSGIVING]: "/bff/plans/plan-icons/emoji-turkey.png",
  [CATEGORIES.HOLIDAY]: "/bff/plans/plan-icons/emoji-holiday.png",
  [CATEGORIES.PALENTINES]: "/bff/plans/plan-icons/emoji-palentine-day.png",
};

type Props = {
  category: CATEGORIES;
  colour: string;
};

export const PlanIcon: FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <div className={styles.root} style={{ background: `#${props.colour}` }}>
      <div className={styles.image}>
        <Image
          src={mapTypeToIconSVG[props.category]}
          alt={`plan-icon-${props.category}`}
          width={100}
          height={100}
        />
      </div>
    </div>
  );
};
